import {Component} from 'react'
import AccountContainer from './AccountContainer.jsx'
import EditDo from './Components/EditDo/EditDo.jsx'
import {toastr} from 'react-redux-toastr'

export default class EditPurchaserContainer extends Component {
  onFormSuccess = () => {
    toastr.success('Les modifications ont correctement été enregistrées')
  }

  render() {
    return <AccountContainer
      view={EditDo}
      onFormSuccess={this.onFormSuccess}
      {...this.props}
    />
  }
}